import { createAction } from 'typesafe-actions';

export const setDebugMode = createAction('core/set_debug_mode')<boolean>();
